import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';

import { clientSingleOptionFormatter } from 'components/forms/autocomplete/Client';

import Data from 'components/Data';

import FormInput from 'components/forms/FormInput';
import FormSwitchery from 'components/forms/FormSwitchery';
import FormAutocomplete from 'components/forms/FormAutocomplete';

import CommissionReceiverEdit from 'components/modals/CommissionReceiverEdit';

class ClientBillingSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showCommissionReceiverChange: false,
    };
  }

  componentDidUpdate = prevProps => {
    const { commissionReceiverFormStatus } = this.props;

    if (
      prevProps.commissionReceiverFormStatus.pending &&
      !commissionReceiverFormStatus.pending &&
      !commissionReceiverFormStatus.hasError
    ) {
      this.closeCommissionReceiverChange();
    }
  };

  closeCommissionReceiverChange = () => {
    this.setState({ showCommissionReceiverChange: false });
  };

  getInvoicingTypes = () => {
    const { intl: { messages }, } = this.props;
    return [
      {label: messages.instantly, value: 'instantly'},
      {label: messages.monthly, value: 'monthly'},
      {label: messages.quarterly, value: 'quarterly'},
      {label: messages.annual, value: 'annual'},
    ]
  }

  render() {
    const {
      intl: { messages },
      intl,
      webApp,
      inModal,
      clientId,
      entity,
      updateEntity,
      disabled,
      commissionReceiver,
    } = this.props;
    const { showCommissionReceiverChange } = this.state;

    const options = [
      { value: 'upon_collection', label: messages.upon_collection },
      { value: '+7days', label: intl.formatMessage({ id: 'number_days' }, { days: 7 }) },
      { value: '+14days', label: intl.formatMessage({ id: 'number_days' }, { days: 14 }) },
      { value: '+1months', label: intl.formatMessage({ id: 'number_months' }, { months: 1 }) },
    ];

    const commissionReceiverValue = (!commissionReceiver.pending &&
      !!commissionReceiver.data &&
      clientSingleOptionFormatter(commissionReceiver.data)) || { value: null, label: messages.unassigned };
    return (
      <Row>
        <Data dataName="commissionReceiver" url={`/api/clients/${clientId}/commissionreceiver.json`} />

        <Col xs={12} md={12}>
          <div className="panel panel-transparent">
            <div className="panel-body">
              <h4>{messages.basic_billing_settings}</h4>
              <div className="form-group-attached">
                <div className="form-group form-group-default padding-10">
                  <FormSwitchery
                    label={messages.use_summary_invoice}
                    name="useSummaryInvoice"
                    checked={entity.getUseSummaryInvoice()}
                    value
                    onChange={updateEntity}
                    disabled={disabled}
                  />
                </div>
                <FormAutocomplete
                  name="invoicing"
                  label={messages.coupon_billing_period}
                  options={this.getInvoicingTypes()}
                  value={entity.getInvoicing()}
                  meta={entity.getInvoicingMetaInformation()}
                  validation={entity.getInvoicingValidationResult()}
                  onChange={updateEntity}
                  disabled={disabled}
                />
                {entity.getUseSummaryInvoice() && (
                  <FormInput
                    label={messages.credit_limit}
                    name="creditLimit"
                    value={entity.getCreditLimit()}
                    meta={entity.getCreditLimitMetaInformation()}
                    validation={entity.getCreditLimitValidationResult()}
                    onChange={updateEntity}
                    disabled={disabled}
                    type="number"
                    min="0"
                    step={0.01}
                    prefixAddon={webApp.currencySymbol}
                  />
                )}
                <FormAutocomplete
                  label={messages.due_date}
                  options={options}
                  value={entity.getPaymentTerms()}
                  onChange={updateEntity}
                  disabled={disabled}
                  name="paymentTerms"
                />
                <div class="form-group form-group-default padding-10">
                  <label>{messages.commission_receiver}</label>
                  <span>
                    {(commissionReceiver.pending && <i className="fa fa-circle-notch fa-spin" />) ||
                      commissionReceiverValue.label}
                  </span>
                  <Button
                    class="m-l-10 btn-rounded"
                    bsSize="xs"
                    onClick={() => this.setState({ showCommissionReceiverChange: true })}
                  >
                    {messages.edit}
                  </Button>
                </div>
                <div className="form-group form-group-default padding-10">
                  <FormSwitchery
                    label={messages.omit_subscription_fee}
                    name="omitSubscriptionFee"
                    checked={entity.getOmitSubscriptionFee()}
                    value
                    onChange={updateEntity}
                    disabled={disabled}
                  />
                </div>
              </div>
            </div>
          </div>
        </Col>

        <CommissionReceiverEdit
          show={showCommissionReceiverChange}
          clientId={clientId}
          close={this.closeCommissionReceiverChange}
        />
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    webApp: state.webApp,
    commissionReceiver: state.data.commissionReceiver,
    commissionReceiverFormStatus: state.formStatus.commissionReceiverEdit,
  };
};

export default injectIntl(connect(mapStateToProps)(ClientBillingSettings));
